import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { valgReducer } from './Valg/Reducers';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { satserReducer } from './Satser/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { composeWithDevTools } from '@redux-devtools/extension';

const rootReducer = combineReducers<VeilederVgsUtenUrAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederVgsUrDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederVgsUrDto>,
    ): EpiContext<VeilederVgsUrDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    satser: satserReducer,
});

export type VeilederVgsUtenUrAppState = EpiAppStateMedSteg<VeilederVgsUrDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>;
};

export default function configureStore(): Store<VeilederVgsUtenUrAppState> {
    return createStore(rootReducer, composeWithDevTools(applyMiddleware(ReduxThunk)));
}
